export interface WeatherData {
    weatherIdx: number;
    date: string;
    dayOfWeek: string;
    weatherAm: string;
    weatherPm: string;
    rainRateAm: number;
    rainRatePm: number;
    minTemp: number;
    maxTemp: number;
    rainfall: number;
    humidity: number;
}

interface WeatherCardProps {
    weather: WeatherData;
}

const getWeatherIcon = (weatherText: string): string => {
    const iconMap: { [key: string]: string } = {
        맑음: 'clear-day.svg',
        구름많음: 'partly-cloudy-day.svg',
        구름조금: 'partly-cloudy-day.svg',
        흐림: 'overcast.svg',
        '구름많고 비': 'partly-cloudy-day-rain.svg',
        '구름많고 눈': 'partly-cloudy-day-snow.svg',
        '구름많고 비/눈': 'partly-cloudy-day-sleet.svg',
        '구름많고 소나기': 'thunderstorms-day-rain.svg',
        '흐리고 비': 'overcast-rain.svg',
        '흐리고 눈': 'overcast-snow.svg',
        '흐리고 비/눈': 'overcast-sleet.svg',
        '흐리고 소나기': 'thunderstorms-rain.svg',
        비: 'rain.svg',
        눈: 'snow.svg',
        '비/눈': 'sleet.svg',
        소나기: 'thunderstorms.svg',
    };
    return `/images/weather/svg/${iconMap[weatherText] || 'clear-day.svg'}`;
};

function WeatherCard({ weather }: WeatherCardProps) {
    return (
        <div className="big-weather-card custom-card">
            {/* 헤더 */}
            <div className="big-weather-header">
                <div className="big-weather-day">{weather.dayOfWeek}</div>
                <div className="big-weather-date">{weather.date}</div>
            </div>

            {/* 날씨 아이콘 영역 */}

            <div className="d-flex gap-3 align-items-center justify-content-center">
                <div className="big-weather-card-icon-container d-flex flex-column ">
                    <div className="weather-am align-self-start">
                        <img
                            src={getWeatherIcon(weather.weatherAm)}
                            alt={weather.weatherAm}
                            className="weather-card-icon "
                        />
                        <span>오전</span>
                    </div>
                    <div
                        className="align-self-center"
                        style={{
                            width: '20px',
                            height: '1px',
                            background: '#e2e8f0',
                            transform: 'rotate(135deg)',
                            marginTop: '-30px',
                            marginLeft: '50px',
                        }}
                    >
                        &nbsp;
                    </div>
                    <div className="weather-pm align-self-end">
                        <span>오후</span>
                        <img
                            src={getWeatherIcon(weather.weatherPm)}
                            alt={weather.weatherPm}
                            className="weather-card-icon"
                        />
                    </div>
                </div>
                <div
                    className="big-weather-period-divider"
                    style={{ height: '60px' }}
                >
                    &nbsp;
                </div>
                <div>
                    {/* 온도 */}
                    <div className="big-weather-card-temp-contaner d-flex justify-content-center align-items-end">
                        <div className="big-weather-card-temp">8°</div>
                    </div>
                    <div className="big-weather-card-temp-contaner d-flex justify-content-center align-items-end">
                        <div className="big-weather-card-temp-min ms-1">
                            <small className="text-muted">최고</small>{' '}
                            {weather.maxTemp}°
                        </div>
                        <div className="big-weather-card-temp-division">/</div>
                        <div className="big-weather-card-temp-min ms-1">
                            <small className="text-muted">최저</small>{' '}
                            {weather.minTemp}°
                        </div>
                    </div>

                    {/* 날씨 설명 */}
                    <div className="big-weather-description mt-3">
                        {weather.weatherAm} / {weather.weatherPm}
                    </div>
                </div>
            </div>

            {/* 구분선 */}
            <div className="big-weather-divider mt-4" />

            {/* 상세 정보 */}
            <div className="big-weather-details">
                <div className="big-weather-detail-item">
                    <div className="big-weather-detail-icon">
                        <i className="ri-celsius-line"></i>️
                    </div>
                    <div className="big-weather-detail-label">최저</div>
                    <div className="big-weather-detail-value">
                        {weather.minTemp}°
                    </div>
                </div>

                <div className="big-weather-detail-item">
                    <div className="big-weather-detail-icon">
                        <i className="ri-drop-line"></i>
                    </div>
                    <div className="big-weather-detail-label">강수량</div>
                    <div className="big-weather-detail-value">
                        {weather.rainfall}mm
                    </div>
                </div>

                <div className="big-weather-detail-item">
                    <div className="big-weather-detail-icon">
                        <i className="ri-water-percent-line"></i>
                    </div>
                    <div className="big-weather-detail-label">습도</div>
                    <div className="big-weather-detail-value">
                        {weather.humidity}%
                    </div>
                </div>
            </div>

            {/* 오전/오후 날씨 */}
            <div className="big-weather-card-periods">
                <div className="big-weather-card-period">
                    <div className="big-weather-card-period-label text-muted">
                        오전
                    </div>
                    <div className="big-weather-card-period-weather">
                        {weather.weatherAm}
                    </div>
                    <div className="big-weather-card-period-rain">
                        <small className="text-muted">강수</small>{' '}
                        {weather.rainRateAm}%
                    </div>
                </div>
                <div className="big-weather-card-period-divider" />
                <div className="big-weather-card-period">
                    <div className="big-weather-card-period-label text-muted">
                        오후
                    </div>
                    <div className="big-weather-card-period-weather">
                        {weather.weatherPm}
                    </div>
                    <div className="big-weather-card-period-rain">
                        <small className="text-muted">강수</small>{' '}
                        {weather.rainRatePm}%
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WeatherCard;
